export default __webpack_public_path__ + "static/media/Ellipse_2.f0d9ced5.png";